import { GenIcon } from '../helpers/IconBase.es.js';

const RewardSilverCircleColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      { tag: "circle", attr: { cx: "12", cy: "12", r: "12", fill: "white" } },
      {
        tag: "path",
        attr: {
          d: "M20.3333 6.71108C19.4129 6.71108 18.6666 7.47719 18.6666 8.42221C18.667 8.60159 18.6951 8.77978 18.75 8.9501L17.3983 9.83219C16.5083 10.4143 15.335 10.2214 14.6666 9.38302L13.3416 7.71898C13.5525 7.42755 13.6664 7.07419 13.6666 6.71112C13.6666 5.76611 12.9204 5 11.9999 5C11.0795 5 10.3332 5.76611 10.3332 6.71112C10.3334 7.07419 10.4474 7.42755 10.6582 7.71898L9.33324 9.38302C8.665 10.2209 7.49219 10.4138 6.60242 9.83219L5.25 8.9501C5.30488 8.77978 5.33301 8.60159 5.33332 8.42221C5.33348 7.47719 4.58742 6.71096 3.66691 6.7108C2.74648 6.71064 2 7.47663 2 8.42165C2 9.30875 2.66008 10.0489 3.52082 10.1265L4.50582 16.1924C4.53922 16.3986 4.71297 16.55 4.91664 16.55H19.0833C19.287 16.55 19.4607 16.3986 19.4941 16.1924L20.4791 10.1265C21.3959 10.0421 22.0725 9.21058 21.9903 8.26933C21.9133 7.38828 21.1949 6.71273 20.3333 6.71108Z",
          fill: "#E5E0D1"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M11.9998 18.261C15.9118 18.261 19.0831 17.3034 19.0831 16.1222C19.0831 14.9409 15.9118 13.9833 11.9998 13.9833C8.08781 13.9833 4.9165 14.9409 4.9165 16.1222C4.9165 17.3034 8.08781 18.261 11.9998 18.261Z",
          fill: "#DDD3C0"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M12 18.6889C8.2725 18.6889 4.5 17.8077 4.5 16.1222C4.5 14.4368 8.2725 13.5555 12 13.5555C15.7275 13.5555 19.5 14.4368 19.5 16.1222C19.5 17.8077 15.7275 18.6889 12 18.6889ZM12 14.4111C7.62332 14.4111 5.33332 15.5233 5.33332 16.1222C5.33332 16.7211 7.62332 17.8333 12 17.8333C16.3767 17.8333 18.6667 16.7211 18.6667 16.1222C18.6667 15.5233 16.3767 14.4111 12 14.4111Z",
          fill: "#F0E9D7"
        }
      }
    ]
  })(props);
};

export { RewardSilverCircleColored };
